import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetQuestionsAnswersByApplicationGuid,
  setQuestionsAnswers,
  UpdateQuestionsAnswersList,
} from "../../../Redux/Reducers/Submitter/QuestionsAnswers";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import InputAHSF from "../../../Components/InputAHSF";
import AttachmentASFH from "../../../Components/AttachmentsAHSF";
import { useParams } from "react-router-dom";

const ResearcherScientificCareer = (props) => {
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.languageReducer.Language);
  const { ApplicationInformationId } = useParams();
  const QuestionsAnswers = useSelector(
    (state) => state.QuestionsAnswers.QuestionsAnswers
  );
  const ValidationScientificContributionSubmitted = useSelector(
    (state) =>
      state.ValidationScientificContributionSubmitted
        .ValidationScientificContributionSubmitted
  );
  const ValiationList = ValidationScientificContributionSubmitted?.result?.map(
    (ele) => ele.fieldName
  );
  const [QuestionsAnswersList, setQuestionsAnswersList] = useState([]);
  const getData = async () => {
    const data = await dispatch(
      GetQuestionsAnswersByApplicationGuid({
        applicationInformationId:
          localStorage.getItem("ApplicationInformationId") ||
          ApplicationInformationId,
      })
    );
    if (data.payload) {
      const withFiles = data.payload?.map((ele) => ({
        ...ele,
        file: null,
      }));
      setQuestionsAnswersList([...withFiles]);
    }
  };

  useEffect(() => {
    getData();
  }, [ApplicationInformationId]);
  useEffect(() => {
    dispatch(setQuestionsAnswers([...QuestionsAnswersList]));
  }, [QuestionsAnswersList]);
  console.log("QuestionsAnswers", ValiationList);

  // return QuestionsAnswers ? (
  //   <>
  //     {QuestionsAnswers &&
  //       QuestionsAnswers?.map((elem, i) => (
  //         <div
  //           className="form-grid"
  //           key={i}
  //           style={{ padding: "5px 30px 0px 30px", marginBottom: "20px" }}
  //         >
  //           <AllDropDownsAHSF
  //             fieldsName="field"
  //             labelName={
  //               lang != "en" ? elem.questionTextAr : elem.questionTextEn
  //             }
  //             disabled={props.disabled}
  //             lang={lang}
  //             show={true}
  //             yesNo={true}
  //             dropdownType="normal"
  //             arrayOoptionList={
  //               lang === "ar"
  //                 ? [
  //                     { text: "نعم", value: true },
  //                     { text: "لا", value: false },
  //                   ]
  //                 : [
  //                     { text: "Yes", value: true },
  //                     { text: "No", value: false },
  //                   ]
  //             }
  //             KeyText={"text"}
  //             KeyValue={"value"}
  //             value={elem?.answer}
  //             onChange={(e) => {
  //               const newValue = JSON.parse(e.target.value);

  //               setQuestionsAnswersList((list) =>
  //                 list.map((obj, index) =>
  //                   index === i ? { ...obj, answer: newValue } : obj
  //                 )
  //               );
  //             }}
  //             showValidationMessage={
  //               ValiationList &&
  //               ValiationList.includes("Questions" + elem.questionTextEn)
  //             }
  //             validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
  //           />
  //           {QuestionsAnswersList[i]?.answer == true ? (
  //             <>
  //               <InputAHSF
  //                 fieldsName="number"
  //                 show={true}
  //                 disabled={props.disabled}
  //                 type="number"
  //                 lang={lang}
  //                 defaultValue={elem?.number}
  //                 onChange={(e) => {
  //                   let newValue = parseInt(e.target.value);
  //                   if (e.target.value == "") {
  //                     newValue = null;
  //                   }
  //                   setQuestionsAnswersList((list) =>
  //                     list.map((obj, index) =>
  //                       index === i ? { ...obj, number: newValue } : obj
  //                     )
  //                   );
  //                 }}
  //                 showValidationMessage={
  //                   ValiationList &&
  //                   ValiationList.includes("Number" + elem.questionTextEn)
  //                 }
  //                 validationMessage={
  //                   lang == "ar" ? "حقل اجباري" : "Field Required"
  //                 }
  //               />
  //               <div>
  //                 <AttachmentASFH
  //                   fieldsName={"attachments"}
  //                   show={true}
  //                   disabled={props.disabled}
  //                   clear={false}
  //                   readOnly={false}
  //                   id={`file-${i}`}
  //                   lang={lang}
  //                   AttachementType="QuestionsAnswers"
  //                   singleFile={elem?.attachments}
  //                   onChange={(e) => {
  //                     const newValue = e.target.files[0];

  //                     setQuestionsAnswersList((list) =>
  //                       list.map((obj, index) =>
  //                         index === i ? { ...obj, file: newValue } : obj
  //                       )
  //                     );
  //                   }}
  //                   showValidationMessage={
  //                     ValiationList &&
  //                     ValiationList.includes(
  //                       "Attachments" + elem.questionTextEn
  //                     )
  //                   }
  //                   validationMessage={
  //                     lang == "ar" ? "حقل اجباري" : "Field Required"
  //                   }
  //                 />
  //               </div>
  //             </>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       ))}
  //   </>
  // ) : (
  //   ""
  // );
  const SaveData = async (file, answer, number, indexf) => {
    const formData = new FormData();

    QuestionsAnswersList.forEach((item, index) => {
      console.log(item,"itemitem");
      
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionsAnswersId`,
        item.questionsAnswersId
      );
      if (index == indexf) {
        formData.append(
          `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].answer`,
          answer
        );
      }else{
          formData.append(
          `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].answer`,
          item.answer??""
        );
      }
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionTextAr`,
        item.questionTextAr ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionTextEn`,
        item.questionTextEn ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].sorting`,
        item.sorting ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionsId`,
        item.questionsId ?? ""
      );
      if (index == indexf) {
        formData.append(
          `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].number`,
          number??""
        );
      }else{
          formData.append(
          `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].number`,
          item.number??"")
      }
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].attachments`,
        item.attachments ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].applicationInformationId`,
        item.applicationInformationId ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].numberShowStatus`,
        item.numberShowStatus ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].attachmentsShowStatus`,
        item.attachmentsShowStatus ?? ""
      );

      if (index == indexf) {
        formData.append(
          `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].file`,
          file??""
        );
      }else{
           formData.append(
          `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].file`,
          item.file??""
        );
      }
    });
    console.log([...formData.entries()], "formData");

    const UpdateQuestions = await dispatch(
      UpdateQuestionsAnswersList(formData)
    );

    if (UpdateQuestions.payload) {
      return true;
    }
  };
  return QuestionsAnswers ? (
    <>
      <div className="qa-grid">
        {QuestionsAnswers?.map((elem, i) => (
          <div className={`qa-item ${lang === "ar" ? "ar" : "en"}`} key={i}>
            {/* Question + Dropdown */}
            <div className="qa-top-row">
              <label className="qa-question">
                {lang !== "en" ? elem.questionTextAr : elem.questionTextEn}
              </label>
              <div className="qa-dropdown">
                <AllDropDownsAHSF
                  fieldsName="field"
                  hidelable="true"
                  disabled={props.disabled}
                  lang={lang}
                  show={true}
                  yesNo={true}
                  dropdownType="normal"
                  arrayOoptionList={
                    lang === "ar"
                      ? [
                          { text: "نعم", value: true },
                          { text: "لا", value: false },
                        ]
                      : [
                          { text: "Yes", value: true },
                          { text: "No", value: false },
                        ]
                  }
                  KeyText="text"
                  KeyValue="value"
                  value={elem?.answer}
                  onChange={(e) => {
                    const newValue = JSON.parse(e.target.value);
                    setQuestionsAnswersList((list) =>
                      list.map((obj, index) =>
                        index === i
                          ? {
                              ...obj,
                              answer: newValue,
                              number: null,
                              file: null,
                              attachments: null,
                            }
                          : obj
                      )
                    );
                    SaveData(null, newValue,null, i);
                  }}
                  showValidationMessage={
                    ValiationList &&
                    ValiationList.includes("Questions" + elem.questionTextEn)
                  }
                  validationMessage={
                    lang === "ar" ? "حقل اجباري" : "Field Required"
                  }
                />
              </div>
            </div>

            {/* Number + Attachment (if answer = Yes) */}
            {QuestionsAnswersList[i]?.answer === true && (
              <div className="qa-bottom-row">
                <div className="qa-input">
                  <InputAHSF
                    fieldsName="number"
                    show={true}
                    disabled={props.disabled}
                    type="number"
                    lang={lang}
                    defaultValue={elem?.number}
                    onChange={(e) => {
                      let newValue = parseInt(e.target.value);
                      if (e.target.value === "") newValue = null;
                      setQuestionsAnswersList((list) =>
                        list.map((obj, index) =>
                          index === i ? { ...obj, number: newValue } : obj
                        )
                      );
                    }}
                    showValidationMessage={
                      ValiationList &&
                      ValiationList.includes("Number" + elem.questionTextEn)
                    }
                    validationMessage={
                      lang === "ar" ? "حقل اجباري" : "Field Required"
                    }
                  />
                </div>

                <div className="qa-attachment">
                  <AttachmentASFH
                    fieldsName="attachments"
                    show={true}
                    disabled={props.disabled}
                    clear={false}
                    readOnly={false}
                    id={`file-${i}`}
                    lang={lang}
                    AttachementType="QuestionsAnswers"
                    singleFile={elem?.attachments}
                    onChange={(e) => {
                      const newValue = e.target.files[0];
                      setQuestionsAnswersList((list) =>
                        list.map((obj, index) =>
                          index === i ? { ...obj, file: newValue } : obj
                        )
                      );
                      console.log(elem?.answer, elem?.number,
                        "Dsdsdddd",QuestionsAnswersList[i]
                      );
                      
                      SaveData(newValue, QuestionsAnswersList[i].answer,QuestionsAnswersList[i].number, i);
                    }}
                    showValidationMessage={
                      ValiationList &&
                      ValiationList.includes(
                        "Attachments" + elem.questionTextEn
                      )
                    }
                    validationMessage={
                      lang === "ar" ? "حقل اجباري" : "Field Required"
                    }
                  />
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  ) : (
    ""
  );
};

export default ResearcherScientificCareer;
